import React, { Component, PropTypes } from 'react'
import { Link } from 'react-router'
import { connect } from 'react-redux'
import { LogoutRequest } from 'client/features/session/actions'
import { ClientsRequest } from 'client/features/client/actions'
import Cut from 'client/features/common/components/Cut.jsx'
import { ReportsRequest, ExportReportsRequest, reportsFiltersChange } from 'client/features/reports/actions'
import { booleansCount, getDataLabel, getUser, getReportsByFilters, multipleCount, getFrameCount, getTypeLabel, isForType } from 'client/features/reports/lib'
import Filters from 'client/features/reports/components/Filters.jsx'
import DeleteReportModal from 'client/features/reports/components/DeleteReportModal.jsx'
import URLS from 'constant/URLS'
import FontAwesome from 'react-fontawesome'
import _ from 'underscore'
import moment from 'moment'
import { getSelectReportsOptions } from 'client/features/reports/lib'
import { makeEndpoint } from 'client/core/api'
import DatePicker from 'react-datepicker'

class Home extends Component {

    constructor() {
        super()
        this.export = this.export.bind(this)
        this.setFilters = this.setFilters.bind(this)
        this.updateDate = this.updateDate.bind(this)
        this.displayReportModal = this.displayReportModal.bind(this)
        this.deleteReport = this.deleteReport.bind(this)
        this.state = {
            fullCurrentReport: null,
            currentReport: null,
            editDate: false,
            showDeleteModal: false
        }
    }

    componentDidMount() {
        this.props.dispatch(ReportsRequest.get.action())
        this.props.dispatch(ClientsRequest.get.action())
    }

    displayReportModal(report) {
        this.setState({
            fullCurrentReport: report,
            showDeleteModal: !this.state.showDeleteModal
        })
    }

    deleteReport() {

    }

    logout() {
        LogoutRequest.get.action()
    }

    activeReport(currentReport) {
        if (this.state.currentReport === currentReport) currentReport = null
        this.setState({
            currentReport,
            editDate: false
        })
    }

    editDate() {
        this.setState({
            editDate: !this.state.editDate
        })
    }

    updateDate(date) {
        const { currentReport } = this.state
        this.props.dispatch(ReportsRequest.put.action({
            payload: { 
                date,
                _id: currentReport
            },
            params: {
                _id: currentReport
            }
        }))
        this.setState({
            editDate: false
        })
    }

    deleteReport() {
        const { currentReport } = this.state
        this.props.dispatch(ReportsRequest.delete.action({
            payload: {
                _id: currentReport
            },
            params: {
                _id: currentReport
            }
        }))
        this.setState({
            displayReportModal: false,
            currentReport: null,
            fullCurrentReport: null
        })
    }

    export() {
        this.props.dispatch(ExportReportsRequest.get.action({
            payload: { filters: this.props.reports.filters }
        }))
    }

    setFilters(filters, dispatch) {
        dispatch(reportsFiltersChange({ filters }))
    }

    render() {
        const { filters, search } = this.props.reports
        const haveReports = getSelectReportsOptions(this.props.client.all, this.props.reports.all)[0] ? true : false
        if (!this.props.user) return (<div></div>)
        /*refactor: beuruUuUurk*/
        let exportURL = `${URLS.reports.export}?`
        if (filters && filters.type && filters.type[0]) {
            filters.type.forEach((type) => {
                exportURL += `type=${type}&`
            })
        }
        if (filters && filters.states && filters.states[0]) {
            filters.states.forEach((state) => {
                exportURL += `state=${state}&`
            })
        }
        if (filters && filters.clientCountry && filters.clientCountry[0]) {
            filters.clientCountry.forEach((country) => {
                exportURL += `country=${country}&`
            })
        }
        /*Bueueueurk */
        if (search && search.key && search.value)
            exportURL += `${search.key}=${search.value}&`

        if (!haveReports)
            exportURL = '#'
        
        return (
            <div>
                <h3 className='page-title'>
                    Report
                    {
                        !this.props.user.limited &&
                        <div className='pull-right m-t-25'>
                            <a className='btn btn-primary waves-effect' href={ exportURL } disabled={ !haveReports } target={ haveReports ? '_blank' : '_self' }>
                                <FontAwesome name='file-excel-o' />&nbsp;
                                Export Excel
                            </a>
                        </div>
                    }
                </h3>
                {
                    this.state.fullCurrentReport &&
                        <DeleteReportModal
                            show={ this.state.showDeleteModal }
                            display={ this.displayReportModal }
                            deleteReport={ this.deleteReport }
                            report={ this.state.fullCurrentReport }
                        />
                }
                <div className='card-box'>
                <Filters onSubmit={ this.setFilters } clients={ this.props.client.all } user={ this.props.user }/>
                <div
                    style={{overflowY: "scroll"}}
                >
                <table className='table table-striped m-0 header-fixed'>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th style={ { width: '110px' } }>Date</th>
                            <th>Client</th>
                            <th style={ { width: '70px' } }>Ruche</th>
                            <th style={ { width: '90px' } }>Type</th>
                            <th>Visit</th>
                            <th style={ { width: '40px' } }>Nourris.</th>
                            <th style={ { width: '40px' } }>Trait.</th>
                            <th style={ { width: '40px' } }>Mat. m.</th>
                            <th style={ { width: '40px' } }>To do</th>
                            <th style={ { width: '40px' } }>Mal.</th>
                            <th style={ { width: '40px' } }>Rei.</th>
                            <th style={ { width: '40px' } }>Oeu.</th>
                            <th style={ { width: '40px' } }>Pol.</th>
                            <th style={ { width: '40px' } }>Miel</th>
                            <th style={ { width: '40px' } }>Prél.</th>
                            <th style={ { width: '40px' } }>Cel. Roy.</th>
                            <th style={ { width: '40px' } }>Ru. Peupl.</th>
                            <th style={ { width: '40px' } }>Divi.</th>
                            <th style={ { width: '40px' } }>Etat gen.</th>
                        </tr>
                    </thead>
                    {
                        getReportsByFilters(this.props.reports.all, this.props.reports.filters, this.props.reports.search).map((report) => (
                            <tbody key={ report._id }>
                                <tr onClick={ this.activeReport.bind(this, report._id) } className={ this.state.currentReport === report._id ? 'cursor-pointer active' : 'cursor-pointer' }>
                                    <th scope='row'>{ report.visitNumber }</th>
                                    <td style={ { width: '110px' } }>{ moment(report.created).format('DD/MM/YYYY') }</td>
                                    <td><Cut string={ report.client.name } cut={ 14 } more='.'/></td>
                                    <td>{ report.hive.state === 'dead' && <FontAwesome name='exclamation' /> }{ report.hive.identifier }</td>
                                    <td>
                                        <Cut string={ getTypeLabel(report.type, 'fr', true) } cut={ 10 } more='.'/>
                                    </td>
                                    <td>
                                        {
                                            report.type === 'dead' ?
                                                <span>
                                                    <FontAwesome name='warning' className='error'/>&nbsp;
                                                    Colonie morte
                                                </span>
                                            : 
                                            <Cut string={ getDataLabel('visit', report.visit) } cut={ 20 } more='.'/>
                                        }
                                    </td>
                                    <td>
                                        {
                                            report.feeding_bak ? 
                                                <Cut string={ getDataLabel('feeding_bak', report.feeding_bak) } cut={ 20 } more='.'/>
                                            :
                                                report.feeding_bak2 ?
                                                    report.feeding_bak2
                                                :
                                                    <Cut string={ getDataLabel('feeding', report.feeding) } cut={ 20 } more='.'/>
                                        }
                                    </td>
                                    <td>
                                        {
                                            report.treatment_bak ? 
                                                <Cut string={ getDataLabel('treatment_bak', report.treatment_bak) } cut={ 20 } more='.'/>
                                            :
                                                report.treatment_bak2 ? 
                                                    report.treatment_bak_2
                                                :
                                                <Cut string={ getDataLabel('treatment', report.treatment) } cut={ 20 } more='.'/>
                                        }
                                    </td>
                                    <td>
                                        {
                                            isForType(report.type, 'missingMaterials') ?
                                                multipleCount(report.missingMaterials) 
                                            : ''
                                        }
                                    </td>
                                    <td>
                                        {
                                            isForType(report.type, 'toDo') ?
                                                multipleCount(report.toDo)
                                            : ''
                                        }
                                    </td>
                                    <td>
                                        {
                                            isForType(report.type, 'maladies') ?
                                                booleansCount(report.maladies)
                                            : ''
                                        }
                                    </td>
                                    <td>
                                        {
                                            isForType(report.type, 'queen') ?
                                                report.queen ? <FontAwesome name='check' /> : <FontAwesome name='remove' />
                                            : ''
                                        }
                                    </td>
                                    <td>
                                        {
                                            isForType(report.type, 'eggs') ?
                                                report.eggs ? <FontAwesome name='check' /> : <FontAwesome name='remove' />
                                            : ''
                                        }
                                    </td>
                                    <td>
                                        {
                                            isForType(report.type, 'pollen') && report.pollenEval === undefined ?
                                                report.pollen ? <FontAwesome name='check' /> : <FontAwesome name='remove' />   
                                            : ''
                                        }
                                        {
                                            isForType(report.type, 'pollenEval') ?
                                                <Cut string={ getDataLabel('pollenEval', report.pollenEval) } cut={ 4 } more='.'/>
                                            : ''
                                        }
                                    </td>
                                    <td>
                                        {
                                            isForType(report.type, 'honey')&& report.honeyEval === undefined ?
                                                report.honey ? <FontAwesome name='check' /> : <FontAwesome name='remove' />   
                                            : ''
                                        }
                                        {
                                            isForType(report.type, 'honeyEval') ?
                                                <Cut string={ getDataLabel('honeyEval', report.honeyEval) } cut={ 4 } more='.'/>
                                            : ''
                                        }
                                    </td>
                                    <td>
                                        {
                                            isForType(report.type, 'sample') ?
                                                <span><strong>{ report.sampleNumber }</strong></span>
                                            : ''
                                        }
                                    </td>
                                    <td>
                                        {
                                            isForType(report.type, 'royalCells') ?
                                                report.royalCells || report.royalCells_bak ? <FontAwesome name='check' /> : <FontAwesome name='remove' />  
                                            : ''
                                        }
                                    </td>
                                    <td>
                                        {
                                            isForType(report.type, 'populatedLanes') ?
                                                report.populatedLanes 
                                            : ''
                                        }
                                        {
                                            isForType(report.type, 'populatedLanesEval') ?
                                                <Cut string={ getDataLabel('populatedLanesEval', report.populatedLanesEval) } cut={ 4 } more='.'/>
                                            : ''
                                        }
                                    </td>
                                    <td>
                                        {
                                            isForType(report.type, 'division') ?
                                                report.division ? <FontAwesome name='check' /> : <FontAwesome name='remove' /> 
                                            : ''
                                        }
                                    </td>
                                    <td>
                                        {
                                            isForType(report.type, 'hiveState') ?
                                                report.hiveState ? <FontAwesome name='check' /> : <FontAwesome name='remove' /> 
                                            : ''
                                        }
                                    </td>
                                </tr>
                                {
                                    this.state.currentReport === report._id ?
                                    <tr>
                                        <td colSpan='19'>
                                            <h4>{ getDataLabel('visit', report.visit) } { getTypeLabel(report.type) }  -&nbsp;
                                                {
                                                    this.props.user.limited ?
                                                        <span>{ report.client.name }</span>
                                                    :
                                                    <Link to={ makeEndpoint(URLS.client.show, report.client) }>
                                                        { report.client.name }
                                                    </Link>
                                                }
                                                <a className='btn btn-danger btn-xs waves-effect pull-right' onClick={ this.displayReportModal.bind(this, report) }>
                                                    Supprimer
                                                </a>
                                            </h4>
                                            {
                                                report.sample &&
                                                    <p>
                                                        Prélèvement: <strong>{ report.sampleNumber }</strong> - { getDataLabel('sample', report.sample) }
                                                    </p>
                                            }
                                            <div className='row-fluid'>
                                                <div className='col-md-8 col-xs-6'>
                                                    <p>
                                                        <FontAwesome name='user'/>&nbsp;
                                                        <span>
                                                            { report.user.firstName } { report.user.lastName } @&nbsp;
                                                            { 
                                                                /*this.state.editDate ?
                                                                    <span>
                                                                        <DatePicker
                                                                            selected={ moment(report.created) }
                                                                            onChange={ this.updateDate }
                                                                            dateFormat='DD/MM/YYYY'
                                                                            customInput={ <span>Cliquer ici pour changer la date</span> }
                                                                        />
                                                                    </span>
                                                                :
                                                                    <a onClick={ this.editDate.bind(this) }>{ moment(report.created).format('DD/MM/YYYY') }</a>*/
                                                            }
                                                            { /*<a onClick={ this.editDate.bind(this) }>{ moment(report.created).format('DD/MM/YYYY') }</a> */}
                                                            <span>
                                                                <DatePicker
                                                                    selected={ moment(report.created) }
                                                                    onChange={ this.updateDate }
                                                                    dateFormat='DD/MM/YYYY'
                                                                    customInput={ <a style={{ cursor: 'pointer' }}>{ moment(report.created).format('DD/MM/YYYY') }</a> }
                                                                />
                                                            </span>
                                                        </span>
                                                    </p>
                                                    <blockquote>
                                                        { report.comment }
                                                    </blockquote>
                                                    <hr />
                                                    <div className='row'>
                                                        <div className='col-md-6 col-xs-12'>
                                                            <h5>Matériel manquant</h5>
                                                            <ul>
                                                            {
                                                                report.missingMaterials.map((material) =>
                                                                    <li key={ material }>
                                                                        { getDataLabel('missingMaterials', material, 'fr') }
                                                                    </li>
                                                                )
                                                            }
                                                            </ul>
                                                        </div>
                                                        <div className='col-md-6 col-xs-12'>
                                                            <h5>A faire lors de la prochaine visite</h5>
                                                            <ul>
                                                            {
                                                                report.toDo.map((task) =>
                                                                    <li key={ task }>
                                                                        { getDataLabel('toDo', task, 'fr') }
                                                                    </li>
                                                                )
                                                            }
                                                            </ul>
                                                        </div>
                                                        <div className='row'>
                                                            <div className='col-md-6 col-xs-12'>
                                                                <h5>Maladies</h5>
                                                                <ul>
                                                                {
                                                                    Object.keys(report.maladies).map((key) => 
                                                                        report.maladies[key] ?
                                                                            <li key={ key }>
                                                                                { getDataLabel('maladies', key) }
                                                                            </li>
                                                                        : null
                                                                    )
                                                                }
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {
                                                    isForType(report.type, 'frames') &&
                                                    <div className='col-md-4 col-xs-12 m-b-8'>
                                                        <table className='table m-0 header-fixed'>
                                                            <thead>
                                                                <tr>
                                                                    <th>Cadre</th>
                                                                    <th>Couvain</th>
                                                                    <th>Nectar</th>
                                                                    <th>Pollen</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    report.frames.map((frame, index) => (
                                                                        <tr key={ index }>
                                                                            <th>{ index + 1 }</th>
                                                                            <td>{ frame && frame.brood ? frame.brood : '0' }</td>
                                                                            <td>{ frame && frame.nectar ? frame.nectar : '0' }</td>
                                                                            <td>{ frame && frame.pollen ? frame.pollen : '0' }</td>
                                                                        </tr>
                                                                    ))
                                                                }
                                                                <tr>
                                                                    <th>TOTAL</th>
                                                                    <td>{ getFrameCount(report.frames, 'brood') }</td>
                                                                    <td>{ getFrameCount(report.frames, 'nectar') }</td>
                                                                    <td>{ getFrameCount(report.frames, 'pollen') }</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                }
                                            </div>
                                        </td>
                                    </tr>
                                    : null
                                }
                            </tbody>
                        ))
                    }
                </table>
                </div>
                </div>
            </div>
        )
    }
}

Home.contextTypes = {
    router: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired,
    user: PropTypes.object
}

const mapStateToProps = (state) => {
    const { session, reports, client } = state
    return { user: session.user, reports, client }
}

export default connect(mapStateToProps)(Home)


// WEBPACK FOOTER //
// ./src/client/features/home/containers/Home.jsx